module.exports = __webpack_public_path__ + "img/couples-042.4065b9b5.jpg";